var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"email-template-link-section default-email-message-template__section"},[_vm._t("prepend"),_c('img',{staticClass:"default-email-message-template__button",attrs:{"src":_vm.linkName,"alt":"button-link"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }